module.exports = __webpack_public_path__ + "img/volcano.e01cc98c.gif";